import request from '@/utils/request'

export function getSiteList(params) {
  return request({
    url: '/cmm/site/getSiteList',
    method: 'post',
    data: params
  })
}

export function getSiteSearchList(params) {
  return request({
    url: '/cmm/site/getSiteSearchList',
    method: 'post',
    data: params
  })
}
